import React from "react";
import { Outlet } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { useContent } from "@/context/ContentContext";

export default function PublicLayout() {
  const { content } = useContent();
  return (
    <div className="grain min-h-screen">
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer settings={content?.settings || {}} />
    </div>
  );
}
